import { useState } from 'react';
import CommonTabContent from '../../../components/common-tab-content';

const options = ['Extract entities', 'Extract products', 'Extract agent spoken sentences'];
interface PromptText {
	[key: number]: string;
}
const promptText: PromptText = {
	0: 'Extract any entities from the given text. List each entity only once, with each unique entity on a separate line. Output only this list of entities, with no accompanying message.',
	1: 'Extract any products mentioned in the given text. List each product only once, with each unique product on a separate line. Output only this list of products, with no accompanying message. Provide output in markdown format.',
	2: 'Extract all sentences spoken by the service agent in the given text. Each sentence must be on a separate line. Output only this list of sentences, with no additional explanation. Provide output in markdown format.',
};

const ParseTabContent: React.FC = () => {
	const [promptValue, setPromptValue] = useState<string>(promptText[0]);

	const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOptionIndex = parseInt(e.target.value);
		setPromptValue(promptText[selectedOptionIndex]);
	};
	return (
		<div className="max-w-2xl">
			<div className="mb-4">
				<select
					className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
					onChange={handleSelectChange}
				>
					{options.map((item, index) => (
						<option key={index} value={index}>
							{item}
						</option>
					))}
				</select>
			</div>
			<CommonTabContent defaultPrompt={promptValue} />
		</div>
	);
};

export default ParseTabContent;
